module.exports = __webpack_public_path__ + "img/12.f22e1638.jpg";